import { default as React, } from "react";
import { FlexContainer } from "../grid/flexcontainer";
import { Icon } from "./icon";
import { Grid } from "../grid/grid";
import { GridItem } from "../grid/griditem";
import { css, cx } from "emotion";
import { getThemeColorVar } from "../helper/color";
const dialogHeaderClass = css({
    fontSize: "18px",
    fontWeight: 600,
    padding: "20px",
    color: getThemeColorVar("white", undefined),
    backgroundColor: getThemeColorVar("background", "dark"),
    whiteSpace: "nowrap",
});
const modifierClasses = {
    danger: css({
        backgroundColor: getThemeColorVar("negative", "default"),
    }),
};
export const DialogHeader = (props) => {
    const classes = [dialogHeaderClass];
    props.modifier && classes.push(modifierClasses[props.modifier]);
    return (React.createElement("div", { className: cx(classes) },
        React.createElement(FlexContainer, { "md-justify": "spaceBetween" },
            React.createElement(Grid, { columnSpec: "fit-content(100%) 1fr", gap: "md" },
                props.icon && React.createElement(Icon, { size: "regular", name: props.icon }),
                React.createElement(GridItem, { alignSelf: "center" }, props.title)),
            props.closeButton && (React.createElement("div", { style: { cursor: "pointer" }, onClick: props.onClose },
                React.createElement(Icon, { name: "close" }))),
            props.children)));
};
export default DialogHeader;
//# sourceMappingURL=dialogheader.js.map